import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideUsers, lucideClipboardList, lucideBell, lucideMessageSquare, lucideUpload, lucideFileText, lucideReceipt } from '@ng-icons/lucide';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NgIcon],
  viewProviders: [provideIcons({ lucideUsers, lucideClipboardList, lucideBell, lucideMessageSquare, lucideUpload, lucideFileText, lucideReceipt })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <nav class="hidden lg:flex flex-col w-60 border-r bg-card h-full p-4 gap-1">
      <a
        routerLink="/customers"
        routerLinkActive="bg-muted text-primary font-medium"
        class="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors duration-200 min-h-[44px] cursor-pointer"
      >
        <ng-icon name="lucideUsers" class="size-4 shrink-0" />
        Customers
      </a>

      <a
        routerLink="/audit-log"
        routerLinkActive="bg-muted text-primary font-medium"
        class="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors duration-200 min-h-[44px] cursor-pointer"
      >
        <ng-icon name="lucideClipboardList" class="size-4 shrink-0" />
        Audit Log
      </a>

      <a
        routerLink="/notifications"
        routerLinkActive="bg-muted text-primary font-medium"
        class="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors duration-200 min-h-[44px] cursor-pointer"
      >
        <ng-icon name="lucideBell" class="size-4 shrink-0" />
        Notifications
      </a>

      <a
        routerLink="/requests"
        routerLinkActive="bg-muted text-primary font-medium"
        class="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors duration-200 min-h-[44px] cursor-pointer"
      >
        <ng-icon name="lucideMessageSquare" class="size-4 shrink-0" />
        Requests
      </a>

      <a
        routerLink="/invoice-upload"
        routerLinkActive="bg-muted text-primary font-medium"
        class="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors duration-200 min-h-[44px] cursor-pointer"
      >
        <ng-icon name="lucideUpload" class="size-4 shrink-0" />
        Invoice Upload
      </a>

      <a
        routerLink="/invoices"
        routerLinkActive="bg-muted text-primary font-medium"
        class="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors duration-200 min-h-[44px] cursor-pointer"
      >
        <ng-icon name="lucideFileText" class="size-4 shrink-0" />
        Invoices
      </a>

      <a
        routerLink="/billing"
        routerLinkActive="bg-muted text-primary font-medium"
        class="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-foreground hover:bg-muted transition-colors duration-200 min-h-[44px] cursor-pointer"
      >
        <ng-icon name="lucideReceipt" class="size-4 shrink-0" />
        Billing
      </a>
    </nav>
  `,
})
export class AppSidebarComponent {}
